import { isApiNotFoundStatus } from '../../../utils/api'
import {
  APPLICANT_STAGE,
  getRentalPortalApplicantIdentityLabel,
} from '../../RentalPortalApplicant'

export function getApplicantProfileTitle({ applicantData, t }) {
  return applicantData
    ? getRentalPortalApplicantIdentityLabel({ applicant: applicantData, t })
    : null
}

export function getHasApplicantProfileLoadFailed({
  applicantData,
  isInitiated,
  serverError,
}) {
  return Boolean(serverError) || (isInitiated && !applicantData)
}

export function getIsApplicantProfileNotFound(serverError) {
  return isApiNotFoundStatus(serverError?.status)
}

export function getIsApplicantFourEyesRequired(applicantData) {
  return applicantData?.policy?.four_eyes_required
}

export function getIsApplicantSelectionRejected(applicantData) {
  return Boolean(applicantData?.rejected_at)
}

export function getIsApplicantSelectedStage(applicantData) {
  return applicantData?.stage === APPLICANT_STAGE.selected
}

export function getIsApplicantDecisionAwaiting(applicantData) {
  return (
    getIsApplicantSelectedStage(applicantData) &&
    !applicantData.approved_by &&
    !getIsApplicantSelectionRejected(applicantData)
  )
}

export function getIsApplicantClosed(applicantData) {
  return Boolean(
    applicantData?.archived ||
    applicantData?.phase?.is_terminal ||
    applicantData?.terminal_at
  )
}
